/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const autoSourceClipsFromSubtitlesV1DataSchema = z.object({
  created: z.number(),
  skipped: z.number(),
});

export type IAutoSourceClipsFromSubtitlesV1Data = z.infer<
  typeof autoSourceClipsFromSubtitlesV1DataSchema
>;

export const autoSourceClipsFromSubtitlesV1ResponseSchema = createApiResponseSchema(
  autoSourceClipsFromSubtitlesV1DataSchema,
) as z.ZodSchema<IAPI<IAutoSourceClipsFromSubtitlesV1Data>>;

export type IAutoSourceClipsFromSubtitlesV1Response = IAPI<IAutoSourceClipsFromSubtitlesV1Data>;
